import tabs from '@featuresIsport/tabs';
import DataFilter from '../../../filters/dataFilter';

/**
 * Vykreslí všechny události do kontejneru s atributy [data-match-comments] [data-match-sport].
 *
 * @param {Array} events - pole udalostí z websocketu
 */
export const detailMatchPageCommentsController = (events: any) => {
  const commentsContainer = document.querySelector<HTMLElement>(`[data-match-comments]`);

  if (!commentsContainer) {
    console.warn('Nenájdený kontajner pre komentáre!');
    return;
  }

  const matchSport = commentsContainer.getAttribute('data-match-sport');
  const tabPanelMatchComments = commentsContainer.querySelector(
    `[data-tab-panel="detail-match-info-tab-0"]`
  );

  // Zistime ci uz je vykresleny filter - nemazat
  const existedFilter = commentsContainer.querySelector(`[data-filter]`);

  if (tabPanelMatchComments) {
    // Ak neexistuje už Filter tak vytvorí nový celý filter a vloží ho do cieľového panelu
    // Inak aktualizuje iba komentáre
    if (!existedFilter && matchSport) {
      const filtersWrapper = createFiltersWrapper(events, matchSport);
      tabPanelMatchComments.appendChild(filtersWrapper);
    } else {
      updateComments(commentsContainer, events);
    }

    // Po pridaní nového DOM obsahu re-inicializujeme filter
    reinitializeDataFilters();
  }

  // const commentsContainer = createCommentsContainer(events);
  // tabPanelMatchComments.appendChild(commentsContainer);

  // const commentsDiv = document.createElement('div');
  // commentsDiv.className = 'comments';
  // commentsDiv.setAttribute('data-filter-content', '');
  //
  // events.forEach((event: any) => {
  //   const el = createEventElement(event);
  //   commentsDiv.appendChild(el);
  // });

  // ak su taby skryte, zobraz prvy "Komentar zapasu
  const tabMatchComments = commentsContainer.querySelector(
    `[data-tab-id="detail-match-info-tab-0"]`
  );
  if (
    commentsContainer.classList.contains('tabs--hidden') ||
    (tabMatchComments && tabMatchComments.classList.contains('tabs__item--hidden'))
  ) {
    tabMatchComments?.classList.remove('tabs__item--hidden');

    const tabsElement = commentsContainer.querySelector(`[data-tabs]`) as HTMLElement;

    tabsElement && tabs(tabsElement);
  }
};

/**
 * Vytvorí hlavičku filtrov so swiper navigáciou.
 * @returns {HTMLElement} Element s hlavičkou filtrov.
 */
const createFiltersHeader = (matchSport: string) => {
  const isAvailableCardFilter = ['fot', 'fut', 'flo', 'haz', 'bas'].includes(matchSport);

  const header = document.createElement('div');
  header.className = 'filters__header';
  header.setAttribute('data-filter-header', '');

  const swiper = document.createElement('div');
  swiper.className = 'swiper swiper--mobile-navigation swiper--theme-light';
  swiper.setAttribute('data-swiper', '');
  swiper.setAttribute('data-swiper-end-fade', 'true');

  const swiperContainer = document.createElement('div');
  swiperContainer.className = 'swiper__container';
  swiperContainer.setAttribute('data-swiper-container', '');

  const swiperList = document.createElement('div');
  swiperList.className = 'swiper__list hideScrollbar';
  swiperList.setAttribute('data-swiper-list', '');

  // Pomocná funkcia pre vytvorenie položky swiperu
  const createSwiperItem = (text: any, filterTrigger: any, isActive = false) => {
    const item = document.createElement('div');
    item.className = 'swiper__item';
    item.setAttribute('data-swiper-item', '');

    const button = document.createElement('button');
    button.className = 'chip chip--outlined chip--default chip--md chip--clickable';
    button.setAttribute('data-filter-trigger', filterTrigger);
    if (isActive) {
      button.setAttribute('data-is-active', 'true');
    }

    const span = document.createElement('span');
    span.className = 'typography typography--label chip__label';
    span.textContent = text;

    button.appendChild(span);
    item.appendChild(button);
    return item;
  };

  swiperList.appendChild(createSwiperItem('Vše', 'reset', true));
  swiperList.appendChild(createSwiperItem('Důležité momenty', 'important'));
  swiperList.appendChild(createSwiperItem('Góly', 'goal'));

  if (isAvailableCardFilter) {
    swiperList.appendChild(createSwiperItem('Střídání', 'change'));
    swiperList.appendChild(createSwiperItem('Karty', 'card'));
  }

  swiperContainer.appendChild(swiperList);
  swiper.appendChild(swiperContainer);
  header.appendChild(swiper);
  return header;
};

/**
 * Vytvorí kontajner pre eventy (komentáre).
 * @param {Array} events Pole eventov.
 * @returns {HTMLElement} Element obsahujúci všetky eventy.
 */
const createCommentsContainer = (events: any) => {
  // Existujúci kontajner s eventmi, ak už je v DOM
  let commentsDiv = document.querySelector('.comments[data-filter-content]');

  if (!commentsDiv) {
    commentsDiv = document.createElement('div');
    commentsDiv.className = 'comments';
    commentsDiv.setAttribute('data-filter-content', '');
  }

  // Pretože nové eventy prichádzajú v poli ako prvé (nové majú nižší index),
  // prechádzame pole v opačnom poradí, aby sme pri vkladaní pomocou insertBefore zachovali poradie.
  for (let i = events.length - 1; i >= 0; i--) {
    const event = events[i];
    if (!commentsDiv.querySelector(`[id="${event.id}"]`)) {
      const eventEl = createEventElement(event);

      // Nový event na začiatok kontajnera.
      commentsDiv.insertBefore(eventEl, commentsDiv.firstChild);
    }
  }

  return commentsDiv;

  // const commentsDiv = document.createElement('div');
  // commentsDiv.className = 'comments';
  // commentsDiv.setAttribute('data-filter-content', '');
  // events.forEach((event: any) => {
  //   const eventEl = createEventElement(event);
  //   commentsDiv.appendChild(eventEl);
  // });
  // return commentsDiv;
};

const updateComments = (wrapper: HTMLElement, events: any) => {
  const commentsEl = wrapper.querySelector('.comments[data-filter-content]');
  if (!commentsEl) return;

  // Pretože nové eventy prichádzajú v poli ako prvé (nové majú nižší index),
  // prechádzame pole v opačnom poradí, aby sme pri vkladaní pomocou insertBefore zachovali poradie.
  for (let i = events.length - 1; i >= 0; i--) {
    const event = events[i];

    if (!commentsEl.querySelector(`[id="${event.id}"]`)) {
      const eventEl = createEventElement(event);

      // Nový event na začiatok kontajnera.
      commentsEl.insertBefore(eventEl, commentsEl.firstChild);
    }
  }
};

/**
 * Zostaví celý wrapper obsahujúci hlavičku filtrov, info-box a kontajner s eventmi.
 * @param {Array} events Pole eventov.
 * @returns {HTMLElement} Kompletný wrapper pre filters.
 */
const createFiltersWrapper = (events: any, matchSport: string) => {
  const wrapper = document.createElement('div');
  wrapper.className = 'filters';
  wrapper.setAttribute('data-filter', '');

  const filterHeader = createFiltersHeader(matchSport);
  const commentsContainer = createCommentsContainer(events);

  filterHeader && wrapper.appendChild(filterHeader);
  wrapper.appendChild(commentsContainer);

  return wrapper;
};

/**
 * Vytvorí HTML element pre jednu udalosť na základe jej typu.
 *
 * @param {Object} event - objekt udalosti
 * @returns {HTMLElement} - vytvorený element udalosti
 */
const createEventElement = (event: any) => {
  // Mapovanie typov
  const typeConfig: any = {
    normal: {
      boxClass: 'commentary-box--normal',
      target: 'normal',
      label: '', // Pre "normal" udalosť nemáme popis (label)
    },
    change: {
      boxClass: 'commentary-box--change',
      target: 'change',
      label: 'Střídání',
      svgIcon:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="#D32E2F" d="M6 12c0 3.31 2.69 6 6 6v-3l4 4-4 4v-3c-4.42 0-8-3.58-8-8 0-1.57.46-3.03 1.24-4.26L6.7 9.2c-.45.83-.7 1.79-.7 2.8"></path><path fill="#60A562" d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46A7.93 7.93 0 0 0 20 12c0-4.42-3.58-8-8-8"></path></svg>',
    },
    important: {
      boxClass: 'commentary-box--important',
      target: 'important',
      label:
        '<div class="badge-pill badge-pill--soft badge-pill--warning badge-pill--md "><div class="badge-pill__icon"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"><path fill="#EC0E0E" d="m10 14.6 3.458 2.091a.831.831 0 0 0 1.242-.9l-.917-3.933 3.059-2.65c.558-.483.258-1.4-.475-1.458l-4.025-.342-1.575-3.717c-.284-.675-1.25-.675-1.534 0L7.658 7.4l-4.025.341C2.9 7.8 2.6 8.716 3.158 9.2l3.059 2.65-.917 3.933a.831.831 0 0 0 1.242.9z"></path></svg></div><span class="typography typography--uppercase  typography--meta-bold badge-pill__label" id="63002727" order="63002727000" written="2025-02-09 06:01:42" last_change="2025-02-09 06:01:42" label="important" label2="" type="" country_code="" external_id="" score1="1" score2="0" shootout_score1="0" shootout_score2="0" relates_to="">Důležitý moment</span></div>',
    },
    yellowCard: {
      boxClass: 'commentary-box--yellowCard',
      target: 'card',
      label: 'Žlutá karta',
      svgIcon:
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14.4" height="19.2" x="4.8" y="2.4" fill="#FAC04F" rx="2"></rect></svg>',
    },
    redCard: {
      boxClass: 'commentary-box--redCard',
      target: 'card',
      label: 'Červená karta',
      svgIcon:
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4.80005" y="2.40039" width="14.4" height="19.2" rx="2" fill="#D32E2F"/></svg>',
    },
    secondRedCard: {
      boxClass: 'commentary-box--redCard',
      target: 'card',
      label: 'Druhá červená karta',
      svgIcon:
        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.7998 2.40039C5.69524 2.40039 4.7998 3.29582 4.7998 4.40039V7H10C10.5523 7 11 7.44772 11 8V17C11 17.5523 10.5523 18 10 18H4.7998V19.6004C4.7998 20.705 5.69524 21.6004 6.79981 21.6004H17.1998C18.3044 21.6004 19.1998 20.705 19.1998 19.6004V4.40039C19.1998 3.29582 18.3044 2.40039 17.1998 2.40039H6.7998Z" fill="#D32E2F"/><rect x="3" y="7" width="8" height="11" rx="1" fill="#FAC04F"/></svg>',
    }, // todo overit
    assist: {
      boxClass: 'commentary-box--assist',
      target: 'card',
      label: 'Asistence',
      svgIcon:
        '<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 20 20" xml:space="preserve"><g fill="#000000"><polygon points="7.8,10.5 10.2,10.5 9,6.5 	"/><path d="M14,1H4C2.3,1,1,2.3,1,4v10c0,1.7,1.3,3,3,3h10c1.7,0,3-1.3,3-3V4C17,2.3,15.7,1,14,1z M11.5,14.7l-0.7-2.1H7.1l-0.7,2.1 H3.5L7.7,3.3h2.6l4.2,11.4H11.5z"/></g></svg>',
    }, // todo overit
    goal: {
      boxClass: 'commentary-box--goal',
      target: 'goal',
      label: 'Góóól',
    },
    // svg icon futbal <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="#0F1120" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 3.3 1.35-.95a8 8 0 0 1 4.38 3.34l-.39 1.34-1.35.46L13 6.7zm-3.35-.95L11 5.3v1.4L7.01 9.49l-1.35-.46-.39-1.34a8.1 8.1 0 0 1 4.38-3.34M7.08 17.11l-1.14.1A7.94 7.94 0 0 1 4 12c0-.12.01-.23.02-.35l1-.73 1.38.48 1.46 4.34zm7.42 2.48c-.79.26-1.63.41-2.5.41s-1.71-.15-2.5-.41l-.69-1.49.64-1.1h5.11l.64 1.11zM14.27 15H9.73l-1.35-4.02L12 8.44l3.63 2.54zm3.79 2.21-1.14-.1-.79-1.37 1.46-4.34 1.39-.47 1 .73c.01.11.02.22.02.34 0 1.99-.73 3.81-1.94 5.21"></path></svg>
    // svg icon hokej <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><g fill="#191919" fill-rule="evenodd" clip-rule="evenodd"><path d="M3.148 8.606c-.405.336-.48.582-.48.716s.075.38.48.715c.4.33 1.03.666 1.88.964 1.693.593 4.087.975 6.77.975 2.685 0 5.078-.382 6.772-.975.85-.298 1.48-.633 1.88-.964.405-.336.48-.581.48-.715s-.075-.38-.48-.716c-.4-.33-1.03-.666-1.88-.964-1.694-.592-4.088-.974-6.771-.974-2.684 0-5.078.382-6.771.974-.85.298-1.48.633-1.88.964m1.329-2.538C6.39 5.398 8.98 5 11.8 5s5.409.399 7.322 1.068c.953.334 1.783.75 2.392 1.254.603.499 1.085 1.17 1.085 2 0 .829-.482 1.5-1.085 2-.609.503-1.44.92-2.392 1.253-1.913.67-4.502 1.068-7.322 1.068s-5.409-.399-7.322-1.068c-.953-.334-1.783-.75-2.392-1.253-.603-.5-1.085-1.171-1.085-2 0-.83.482-1.501 1.085-2 .609-.504 1.44-.92 2.392-1.254"></path><path d="M5.028 10.994c1.694.591 4.088.971 6.77.971 2.683 0 5.078-.38 6.772-.97.85-.298 1.48-.632 1.88-.962.406-.335.48-.58.48-.712h1.668v5.889l.002.094q0 .118-.027.288c-.04.228-.129.513-.316.825-.377.628-1.103 1.29-2.427 1.836l-.001.001c-1.809.742-3.83 1.07-5.37 1.215a27 27 0 0 1-2.473.116l-.153-.002h-.087l-.162-.001a31 31 0 0 1-2.592-.143c-1.576-.155-3.61-.48-5.247-1.191-1.19-.513-1.878-1.097-2.272-1.623a2.6 2.6 0 0 1-.381-.697 2 2 0 0 1-.088-.375l-.001-.016v-.007l-.001-.003v-.002l.832-.055-.832.054L1 15.497V9.32h1.668c0 .133.074.377.48.712.4.33 1.03.664 1.88.961m-2.36.739v3.65c.014.04.052.125.14.242.184.246.616.669 1.598 1.092l.002.001c1.393.605 3.219.911 4.747 1.061a30 30 0 0 0 2.444.135h.225v.001h.04l.132.002a25 25 0 0 0 2.306-.109c1.468-.138 3.303-.444 4.892-1.096 1.087-.45 1.487-.91 1.633-1.153a.7.7 0 0 0 .104-.26v-3.566a9.3 9.3 0 0 1-1.812.836c-1.913.667-4.502 1.064-7.32 1.064s-5.407-.397-7.32-1.064a9.2 9.2 0 0 1-1.811-.836"></path></g></svg>
    // todo doriesit ikonu pre sporty pre goal
    // U udalosti typu "time" vykresľujeme špeciálny chip
    time: {
      target: 'summary',
    },
  };

  // Špeciálne spracovanie pre typ "time" – renderujeme chip element
  if (event.typ === 'time') {
    const container = document.createElement('div');
    container.setAttribute('data-filter-target', typeConfig.time.target);

    const divider = document.createElement('div');
    divider.className = 'divider divider--chip divider--no-bottom-margin';

    const chip = document.createElement('div');
    chip.className = 'chip chip--fill chip--primary chip--sm';
    chip.id = event.id;

    // chip ikona
    const chipIcon = document.createElement('span');
    chipIcon.className = 'chip__icon';
    chipIcon.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="#191919" d="M15 1.5H9v2h6zm4.03 6.39 1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.96 8.96 0 0 0 12 4.5a9 9 0 0 0-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 0 0 7.03-14.61M13 14.5h-2v-6h2z"></path></svg>';

    const chipLabel = document.createElement('span');
    chipLabel.className = 'typography typography--label chip__label';

    // Ak nie je k dispozícii vlastný text, použijeme predvolenú správu
    chipLabel.innerHTML = event.text || 'Utkání právě začalo.';

    chip.appendChild(chipIcon);
    chip.appendChild(chipLabel);
    divider.appendChild(chip);
    container.appendChild(divider);

    return container;
  }

  // Pre ostatné typy udalostí
  const config = typeConfig[event.typ] || typeConfig.normal;
  const container = document.createElement('div');
  if (event.time !== '') {
    container.classList.add('commentary-box', config.boxClass);
  }
  container.setAttribute('data-filter-target', config.target);
  container.id = event.id;

  const isEmptyTimeEvent = event.time === '';

  // Vytvoríme hlavičku – zobrazí sa čas udalosti
  const header = !isEmptyTimeEvent ? document.createElement('div') : null;
  if (header) {
    header.className = 'commentary-box__header';
  }

  const timeSpan = document.createElement('span');
  timeSpan.className = 'typography typography--body1-bold';
  // Definovaný čas - pridáme apostrof
  timeSpan.textContent = event.time ? event.time + '’' : '';

  if (header) {
    header.appendChild(timeSpan);
  }

  const labelEl = document.createElement('span');
  labelEl.className = 'commentary-box__label';
  if (config.label) {
    const labelText = document.createElement('span');
    labelText.className =
      config.label === 'Góóól'
        ? 'typography typography--body2-bold'
        : 'typography typography--body2 commentary-box__label-text';
    labelText.innerHTML = config.label;
    labelEl.appendChild(labelText);
  }

  if (config.svgIcon) {
    // dočasný element, do ktorého vložíme svg ikonu z configu,
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = config.svgIcon.trim();

    // získame prvý element (SVG) a pripojíme ho.
    const svgElement = tempContainer.firstElementChild;
    if (svgElement) {
      labelEl.appendChild(svgElement);
    }
  }

  if (header) {
    header.appendChild(labelEl);
    container.appendChild(header);
  }

  // Body udalosti – obsahuje text (popis udalosti)
  const body = document.createElement('div');
  body.className = header ? 'commentary-box__body' : '';

  const bodyText = document.createElement('span');
  bodyText.className = 'typography typography--body1 comments__summary';
  bodyText.innerHTML = event.text || '';

  body.appendChild(bodyText);
  container.appendChild(body);

  return container;
};

// todo zvazit presun do componenty dataFitler
function reinitializeDataFilters(): void {
  const filterContainers = document.querySelectorAll('[data-filter]');
  filterContainers.forEach((container) => {
    try {
      // Nová inštance DataFilter pre každý nájdený kontajner
      new DataFilter(container as HTMLElement);
    } catch (error) {
      console.error('Filter initialization error:', error);
    }
  });
}
